import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Config } from "@onsip/common/config";
import { AnimationComponent } from "../../shared/components/animation/animation.component";

@Component({
  selector: "onsip-signup-redirect",
  templateUrl: "./redirect-modal.component.html",
  styleUrls: ["./redirect-modal.component.scss"],
  imports: [MatButtonModule, TranslateModule, AnimationComponent]
})
export class RedirectModalComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA);
  private translate = inject(TranslateService);

  subtitle!: string;
  isSignupComplete = false;
  isBeta = Config.ADMIN_API_URL.includes("beta");

  ngOnInit() {
    switch (this.data) {
      case "signupComplete":
        this.isSignupComplete = true;
        break;
      case "redirectToApp":
        this.subtitle = this.translate.instant("ONSIP_I18N.REDIRECTING_YOU_TO_THE_HOME_PAGE");
        break;
      case "createAccount":
        this.subtitle = this.translate.instant("ONSIP_I18N.CREATING_YOUR_ACCOUNT");
        break;
      case "createTopics":
        this.subtitle = this.translate.instant("ONSIP_I18N.CREATING_YOUR_TOPICS");
        break;
      default:
        this.subtitle = this.translate.instant("ONSIP_I18N.REDIRECTING_YOU_TO_THE_HOME_PAGE");
        break;
    }
  }

  redirectToApp(): void {
    window.location.href = this.isBeta ? "https://app.onsip.com/beta" : "https://app.onsip.com/app";
  }
}
